import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Transfer, FileUploadOptions, TransferObject } from '@ionic-native/transfer';
import { File } from '@ionic-native/file'

import { Events,Platform,normalizeURL } from 'ionic-angular';

/*
  Generated class for the Filetransfer provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/

@Injectable()
export class Filetransfer {
	
	private  fileTransfer: TransferObject = this.transfer.create();

  private static downloadedItems:Array<string>;
  private static downloadingItem:string;

  constructor(public http: Http,private transfer:Transfer,private file:File,public event:Events,public platform:Platform) {
    console.log('Hello Filetransfer Provider');
    this.event.subscribe("app.cancelDownload",()=>{
    	this.fileTransfer.abort();
    })
    Filetransfer.downloadedItems=[];
    Filetransfer.downloadingItem="";
  }

  downloadAudio(url){

  	return new Promise<String>((resolve,reject)=>{
  		var filename = url.substring(url.lastIndexOf('/')+1);
  		 var self=this;

		this.file.checkFile(this.getFileLocation(),"audio/"+ filename).then((status)=>{
  			if(status==false){
		  		this.fileTransfer.onProgress (function(progressEvent) {
						console.log("Publishing progress");
						console.log(progressEvent);
						self.event.publish('app:downloadProgress',progressEvent);
					
				  });

          Filetransfer.downloadingItem=filename;
  				this.fileTransfer.download(url, this.getFileLocation()+"audio/" + filename).then((entry) => {
  					console.log('download complete: ' + entry.toURL());
            Filetransfer.downloadedItems.push(filename);
  					resolve();
  				}, (error) => {
  					console.log("error occurred");		
  					console.log("error occurred");
  					self.event.publish('app:downloadProgress',{status:"downloadError"});
  				});
				  resolve("downloadingFile");
  			}else{
  				resolve(this.getFileLocation()+"audio/"+ filename);
  			}
  		});
  	})
  }

  downloadVideo(url){

  	return new Promise<String>((resolve,reject)=>{
  		var filename = url.substring(url.lastIndexOf('/')+1);
  		 var self=this;
  		 this.file.checkFile(this.getFileLocation(),"images/"+ filename).then((status)=>{
  			if(status==false){
		  		this.fileTransfer.onProgress (function(progressEvent) {
						console.log("Publishing progress");
						console.log(progressEvent);
						self.event.publish('app:downloadProgress',progressEvent);
					
				});
        Filetransfer.downloadingItem=filename;
				this.fileTransfer.download(url, this.getFileLocation() +"video/"+ filename).then((entry) => {
					console.log('download complete: ' + entry.toURL());
          Filetransfer.downloadedItems.push(filename);
					self.event.publish('app:downloadProgress',{status:"downloadComplete",url:this.getFileLocation()+"images/"+ filename});
					//resolve();
				}, (error) => {
					console.log("error occurred");
					self.event.publish('app:downloadProgress',{status:"downloadError"});
				});
				resolve("downloadingFile");
	  		}else{
  				resolve(this.getFileLocation()+"images/"+ filename);
  			}
  		});
  	})
  }


  checkFileInLocal(url:string,type:string){
    return new Promise<String>((resolve,reject)=>{
      if(this.platform.is('core') || this.platform.is('mobileweb')) {
        reject("browser");
      }else{
         var filename = url.substring(url.lastIndexOf('/')+1);
        var self=this;
        console.log(this.getFileLocation()+type+"/"+ filename);
        this.file.checkFile(this.getFileLocation(),type+"/"+ filename).then((status)=>{
            if(status==false){
              resolve("false");
            }else{

              console.log("File exists on local no need to save "+(this.getFileLocation()+type+"/"+ filename));
              this.file.readAsArrayBuffer(this.getFileLocation()+type,filename).then(data=>{
                console.log("data is "+ data);
                var blob=new Blob([data]);
                var url=URL.createObjectURL(blob);
                resolve(url);
              })
              // resolve(this.getFileLocation()+type+"/"+ filename);
            }     
        }).catch(
              err => {
                  console.log("error ");
                  console.log(err);
                  resolve("false");

              }
         );
      }
     
    
    })
  }

  getFileLocation(){
    var directory=this.file.dataDirectory;
    if(this.platform.is('ios')){
      directory=this.file.cacheDirectory;
    }
    return directory;
  }

  downloadFile(url,type){

  	return new Promise<String>((resolve,reject)=>{
    if(url==""){
      resolve();
    }
		var filename = url.substring(url.lastIndexOf('/')+1);
  		 var self=this;
  		this.checkFileInLocal(url,type).then((status)=>{
  			if(status=="false"){
  				this.fileTransfer.onProgress (function(progressEvent) {
						console.log("Publishing progress");
						console.log(progressEvent);
            var data={url:"",progressEvent:{}};
            data.url=url;
            data.progressEvent=progressEvent;
            // if(type!="images")
            self.event.publish('app:downloadProgress',data);
            self.event.publish('app:audioDownloadProgress',data);
					  // self.event.publish('app:updateProgress',data);
					});
          Filetransfer.downloadingItem=filename;
          console.log("Downloading "+url +" testing");
          console.log("Downloading to "+this.getFileLocation()+type +"/"+ filename);
					this.fileTransfer.download(url, this.getFileLocation()+type +"/"+ filename).then((entry) => {
						console.log('download complete: ' + entry.toURL());
            Filetransfer.downloadedItems.push(filename);
             var data={url:"",localurl:""};
            data.url=url;
            data.localurl=this.getFileLocation()+type +"/"+ filename;
            if(type!="images"){
              self.event.publish('app:audioDownloadComplete',data);
            }

            resolve(entry.toURL());
						
					}, (error) => {
						console.log("error occurred");
            
            self.event.publish('app:downloadProgress',{status:"downloadError"});
           
						// resolve("error");
						// handle error
					});
          if(type!="images"){
            reject("Downloading file");
          }else{
            resolve(url);
          }
  			}else{
          console.log(filename+" exists");
  				resolve(this.getFileLocation()+type+"/"+ filename);
  			}		
  		})
  	})
  }


  downloadFileForced(url,type){
    return new Promise<String>((resolve,reject)=>{
    var filename = url.substring(url.lastIndexOf('/')+1);
       var self=this;
      this.checkFileInLocal(url,type).then((status)=>{
        if(status=="false"){
          this.fileTransfer.onProgress (function(progressEvent) {
            // console.log("Publishing progress");
            // console.log(progressEvent);
            var data={url:"",progressEvent:{}};
            data.url=url;
            data.progressEvent=progressEvent;
            self.event.publish('app:downloadProgress',data);
            if(type!="images")
              self.event.publish('app:audioDownloadProgress',data);
          });
          Filetransfer.downloadingItem=filename;
          this.fileTransfer.download(url, this.getFileLocation()+type +"/"+ filename).then((entry) => {
            console.log('download complete: ' + entry.toURL());
             Filetransfer.downloadedItems.push(filename);
             var data={url:"",localurl:""};
            data.url=url;
            data.localurl=this.getFileLocation()+type +"/"+ filename;
            resolve();
          }, (error) => {
            console.log("error occurred");
          });
          
        }else{
          console.log(filename+" exists");
          resolve(this.getFileLocation()+type+"/"+ filename);
        }    
      })
    })
  }

  normalizeURLManually(stringurl){
    var result:string="";
    return  stringurl.replace("file://","");
  }

  saveFileLocally(fileUrl,type){
    var $self=this;
  	return new Promise<String>((resolve,reject)=>{
  		if(this.platform.is('core') || this.platform.is('mobileweb')) {
  			reject("browser");
  		}else{
        this.checkFileInLocal(fileUrl,type).then((status1)=>{
          if(status1=="true"){
            var filename = fileUrl.substring(fileUrl.lastIndexOf('/')+1);
            resolve(this.getFileLocation()+type+"/"+ filename);
          }
    			this.downloadFile(fileUrl,type).then((localurl:string)=>{
            // localurl=localurl.substring(localurl.search('.Library'),localurl.length);
            // if(type=="image")  
            // var stringurl:string=""+localurl;
            // stringurl=$self.normalizeURLManually(stringurl);
            // console.log("After normalize:"+stringurl);
            if(type=="images"){
                var filename = localurl.substring(localurl.lastIndexOf('/')+1);
                var arraybuffer:String="";
                var url=this.getFileLocation()+type+"/"+filename;
                if(this.platform.is('ios')) { //Local files are not working for ios hence generate image using blob feature
                  this.file.readAsArrayBuffer(this.getFileLocation()+type,filename).then(data=>{
                    console.log("data is "+ data);
                    var blob;
                    blob=new Blob([data]);
                    url=URL.createObjectURL(blob);
                     resolve(url);
                  })
                }else{
                   resolve(url);
                }
               
            }else{
                resolve(localurl);
            }
           
  	  			// resolve(arraybuffer);
  	  		},(err)=>{
            reject("error");
          })
        },(err)=>{

	  			reject("error");
	  		})
  		} 		
  	})
  }


  saveFileLocallyForUpdate(fileUrl,type){
    var $self=this;
    return new Promise<String>((resolve,reject)=>{
      if(this.platform.is('core') || this.platform.is('mobileweb')) {
        reject("browser");
      }else{
        this.downloadFileForced(fileUrl,type).then((localurl:string)=>{
           resolve();
        },(err)=>{
          resolve("error");
        })
      }     
    })
  }

  checkFileExist(){


  }

}



// WEBPACK FOOTER //
// ./src/providers/filetransfer.ts